module.exports = __webpack_public_path__ + "static/media/24UHCHR21.261a306a.jpg";